import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import { BLOG_POSTS, postUrl } from "../data/blog";
import Seo, { breadcrumbLd } from "../components/Seo";
import { Reveal, Kicker } from "../components/Reveal";

export default function BlogPage() {
  const { lang, t } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";

  return (
    <div data-testid="blog-page" className="pt-32">
      <Seo
        title={t("seo.blog.title")}
        desc={t("seo.blog.desc")}
        path="/blog"
        jsonLd={breadcrumbLd([
          { name: "EcoGlow Detailing", path: prefix || "/" },
          { name: "Blog", path: `${prefix}/blog` },
        ])}
      />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal><Kicker>{t("blog.kicker")}</Kicker></Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl lg:text-6xl">
            {t("blog.title")}
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400">{t("blog.sub")}</p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {BLOG_POSTS.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}>
              <Link
                to={postUrl(p.slug, lang)}
                data-testid={`blog-card-${p.slug}`}
                className="card-sheen group flex h-full flex-col overflow-hidden rounded-xl border border-white/5 bg-[#121212] transition-all duration-300 hover:-translate-y-1 hover:border-[#63E51D]/50 hover:shadow-[0_0_25px_rgba(99,229,29,0.15)]"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={p.img} alt={p[lang].title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-transparent to-transparent" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#63E51D]">{p.minutes} {t("blog.min")}</span>
                  <h2 className="mt-2 font-display text-xl font-bold uppercase leading-tight tracking-wide text-white group-hover:text-[#8BFF32]">
                    {p[lang].title}
                  </h2>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-zinc-400">{p[lang].excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#63E51D]">
                    {t("blog.read")} <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <div className="pb-10" />
    </div>
  );
}
